import React from "react";

import clsx from "clsx";
import Image from "next/image";

import { Scroll } from "@/components/displays";
import { FEATURE_FLAG } from "@/configs/system";
import { ProductsBySkuCalcPriceModel } from "@/models/product/type";
import { formatCurrency } from "@/utils/currency";

import styles from "./SectionItem.module.scss";
import { useLPStore } from "../../store";

export interface SectionItemProps {
  productSet: ProductsBySkuCalcPriceModel;
  index: number;
}

export function SectionItem({ productSet, index }: SectionItemProps): React.ReactNode {
  const { setSelectIndex } = useLPStore();

  return (
    // SP版にpaddingがいらないため、col-12より、styles.wrapperを使う
    <div className={clsx("col-m-4", styles.wrapper)}>
      <div className={styles.section}>
        <p className="text__bold mg__bottom__m text__center text__small">
          {productSet.subTitle}
          <br /> <span className="text__xxl text__red">{productSet.quantity}</span>
          <span className="text__xl text__red">袋セット</span>
        </p>
        <Image
          src={productSet.images[0].src}
          alt={productSet.name || "セット内容"}
          width={368}
          sizes={`(max-width: 1036px) 280px, (max-width: 1335px) 268px, 368px`}
          style={{ width: "100%", height: "auto" }}
        />
        <div className={clsx("pd__top__m text__center mg__top__m", styles.outline)}>
          <del className="text__s">通常価格{formatCurrency(productSet.defaultPrice)}（税込）</del>
          <div className={styles.priceWrap}>
            <div className={styles.priceTable}>
              <span className={clsx("tag red radius text__white text__s", styles.percent)}>
                20%0FF
              </span>
              <span className={clsx(styles.price, "text__red text__bold")}>
                {formatCurrency(productSet.totalPrice)}
                <span className="text__s text__red text__normal">（税込）</span>
              </span>
            </div>
            {!FEATURE_FLAG.isFreeShippingCampaignActive && (
              <p className={clsx(styles.deliveryFee, "text__s text__right")}>＋送料¥500</p>
            )}
          </div>
          {FEATURE_FLAG.isFreeShippingCampaignActive && (
            <>
              <del className="text__s">＋送料¥500</del>
              <span className={clsx(styles.freeDeliveryFee, "text__m")}>
                → <span className="text__l text__red text__bold">¥0</span>
              </span>
              <p className={"text__m text__bold text__center text__red"}>
                <span className={styles.maker}>今だけ初回送料無料</span>
              </p>
            </>
          )}
          <div className="mg__top__m mg__bottom__m">
            <Scroll
              to="lp-form"
              className={clsx(
                "btn inline-block round text__m text__bold text__white align-middle mx-[5px]",
                styles.greenButton
              )}
              onClick={() => setSelectIndex(index)}
            >
              {productSet.quantity}袋セットを購入
            </Scroll>
          </div>
          <p className="text__s text__gray__dark text__center">
            ※継続コース初回のみ※2回目以降のご購入から {formatCurrency(productSet.secondTotalPrice)}
            （税込）＋送料¥500 ※1回目お届け以降、いつでも内容変更、解約が可能
          </p>
        </div>
      </div>
    </div>
  );
}
